import api from "../../api";

class BackendN1API {
    static list(payload) {
        const params = {
            page: payload?.page,
            take: payload?.take,
        };

        Object.keys(payload.filter ?? {}).forEach((k) => {
            params[`filter[${k}]`] = payload.filter[k] ? payload.filter[k] : undefined;
        });

        return api.get("/backend/n1", { params });
    }

    static create(payload) {
        return api.post(`/backend/n1`, payload);
    }

    static delete(id) {
        return api.delete(`/backend/n1/${id}`);
    }

    static action(type, payload) {
        const { filter = {}, ...params } = payload;

        Object.keys(filter).forEach((k) => {
            !Boolean(filter[k]) && delete filter[k];
        });

        return api.patch(`/backend/n1`, { ...params, filter, action: type });
    }
}

export default BackendN1API;
